
// console.log('All scripts are loaded');


import './sass/features.scss';
// import './sass/pages/large/section__aura.scss';

import common from './js/module/common.js';

// img使用lazyload套件
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// 載入各JS模組
// import DetectWebPmodule from './js/module/DetectWebP';
import lenisSmoothScrooll from './js/module/lenisSmoothScrooll';

import slickCustom from './js/module/slickCustom';
import eachSecScroll from './js/module/eachSecScroll';



// import sectionSliced from './js/section__sliced';
import secKV from './js/module/pages/secKV';
// import secIOports from './js/module/pages/secIOports';
// import secPerformanceCarousel from './js/module/pages/secPerformanceCarousel.js';




import LazyLoad from './js/module/lazyLoadModal';
import revealVideoModule from './js/module/revealVideo';
// import iku from './js/module/iku';
// import sideNavigation from './js/module/sideNavigation';
// import sideNameBar from './js/module/sideNameBar';
// import subscribeEDM from './js/module/subscribeEDM.js';
// import secAura from './js/module/pages/secAura';
import initGaTracking from './js/module/ga/gaTracking.js';

// DetectWebPmodule();
common();

// 執行JS
// file1();
// file2();

LazyLoad();
lenisSmoothScrooll();

secKV();
// secIOports();
// secPerformanceCarousel();

// secAura();



// slickCustom();
// revealVideoModule();
// iku();
// sideNavigation();
// sideNameBar();
eachSecScroll();
// subscribeEDM();
initGaTracking();


